module.exports = __webpack_public_path__ + "static/media/993993.632ad8bc.png";